import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as BetslipActions from 'actions/BetslipActions';
import * as TerminalBetslipActions from 'actions/TerminalBetslipActions';
import * as UiActions from 'actions/UiActions';
import { UI_ERROR_MESSAGE } from 'constants/ui';
import OddsButton from 'ui/Button';
import { isTerminal } from 'utils/UiHelper';
import { OddsButtonWrapper, OddsText } from 'ui/OddsButtonWrapper';
import { getErrorByCode } from '../utils/Helper';

class ViewVinderspilMarkets extends Component {
    onClickHandler() {
        const market = this.props.market;
        const item = this.props.item;
        const isLive = this.props.live;
        const ev = this.props.ev;

        if (!isTerminal()) {
            this.props.betslipActions.addMarket(
                market.marketId,
                item.betNr,
                item.odds,
                isLive,
                market.sportId,
                this.props.betslip.hasMarkets
            );
        } else {
            if (this.props.betslip.betList.length < 15) {
                if (
                    this.props.betslip.betList.filter(
                        (item) => item.eventId === market.eventId
                    ).length === 0
                ) {
                    this.props.terminalBetslipActions.addMarket(
                        this.props.betslip,
                        market.eventId,
                        ev.eventName,
                        market.marketId,
                        item.betNr,
                        0,
                        item.odds,
                        item.bet,
                        market.marketName,
                        ev.live,
                        ev
                    );
                } else {
                    this.props.uiActions.notification(
                        UI_ERROR_MESSAGE,
                        getErrorByCode('BAD_COMBINATION')
                    );
                }
            } else {
                this.props.uiActions.betslipLimit();
            }
        }
    }

    onClickRemoveHandler() {
        const marketId = this.props.market.marketId;

        if (!isTerminal()) {
            if (this.props.betslip.betList.length > 1) {
                this.props.betslipActions.clearSystemMarket(
                    this.props.market.eventId,
                    marketId
                );
            } else {
                this.props.betslipActions.clearSingleMarket(
                    this.props.market.eventId,
                    marketId
                );
            }
        } else {
            this.props.terminalBetslipActions.removeMarket(marketId);
        }
    }

    render() {
        if (this.props.item.odds > 1) {
            const hasMarkets = this.props.betslip.hasMarkets;

            let isOrange = false;

            if (hasMarkets.indexOf(this.props.market.marketId) > -1) {
                this.props.betslip.betList.map((item) => {
                    if (
                        item.gameId === this.props.market.marketId &&
                        item.betText === this.props.item.bet &&
                        item.marketName === this.props.market.marketName
                    ) {
                        isOrange = true;
                    }
                    return item;
                });
            }

            return (
                <OddsButton
                    active={isOrange}
                    width="95%"
                    padding="20px 10px"
                    margin="5px"
                    maxHeight="40px"
                    flex="1"
                    oddsYellow
                    onClick={
                        this.props.disabled
                            ? null
                            : isOrange
                                ? this.onClickRemoveHandler.bind(this)
                                : this.onClickHandler.bind(this)
                    }
                    disabled={this.props.disabled}
                >
                    <OddsButtonWrapper>
                        <OddsText
                            active={isOrange}
                            disabled={this.props.disabled}
                        >
                            {this.props.item.competitor}
                        </OddsText>
                        <p>{this.props.item.odds.toFixed(2)}</p>
                    </OddsButtonWrapper>
                </OddsButton>
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return { betslip: state.betslip };
}

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
        betslipActions: bindActionCreators(BetslipActions, dispatch),
        terminalBetslipActions: bindActionCreators(
            TerminalBetslipActions,
            dispatch
        ),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewVinderspilMarkets);
